import { useCallback, useMemo, useState } from "react";
import {
  countActiveAdvancedCriteria,
  formatAdvancedFilterActiveSummary,
} from "../utils/advancedFilter";

/**
 * Open state and applied criteria for the list filter slide-over.
 * Field edits write `applied` immediately (same as Task Management).
 *
 * @param {{
 *   initialApplied?: Record<string, *>,
 *   fields?: Array<{ id: string, label?: string, type?: string, options?: Array<{ value: *, label?: string }> }>,
 * }} [config]
 */
export function useAdvancedFilter(config = {}) {
  const fields = Array.isArray(config.fields) ? config.fields : null;
  const [open, setOpen] = useState(false);
  const [applied, setApplied] = useState(() =>
    config.initialApplied && typeof config.initialApplied === "object" ? { ...config.initialApplied } : {}
  );

  const activeCount = useMemo(() => countActiveAdvancedCriteria(applied), [applied]);
  const activeSummary = useMemo(
    () => (fields ? formatAdvancedFilterActiveSummary(applied, fields) : ""),
    [applied, fields]
  );

  const clearApplied = useCallback(() => {
    setApplied({});
  }, []);

  return {
    open,
    setOpen,
    applied,
    setApplied,
    activeCount,
    activeSummary,
    clearApplied,
  };
}
